import React from 'react';
import classnames from 'classnames';
import { path } from 'Constants';

const SaveSection = ({
  isUnchanged,
  isLoading,
  error,
  responseMessage,
  pendingUpdates,
  onSave,
  content,
  newValueStory
}) => {
  return (
    <div className="formBg profile-pg" style={{ padding: '5px 0' }}>
      <div className="grid-x align-middle">

        {/* Message */}
        <div
          className={classnames(
            'medium-9',
            { errors: !isUnchanged },
            { success: isUnchanged }
          )}
          style={{ fontSize: '12px' }}
        >
          {error ? (
            <div
              className="errors"
              dangerouslySetInnerHTML={{
                __html: error.replace(/\\n/g, '<br />')
              }}
            />
          ) : isUnchanged ? (
            responseMessage
          ) : newValueStory ? '' : (
            pendingUpdates
          )}
        </div>

        {/* Save icon button */}
        <div style={{ paddingLeft: '5px' }} className="float-left medium-2">
          <button
            className="hand-cursor"
            type="button"
            onClick={onSave}
            disabled={isLoading || isUnchanged}
            style={{
              opacity: isLoading || isUnchanged ? 0.5 : 1,
              pointerEvents: isLoading || isUnchanged ? 'none' : 'auto',
              background: 'transparent',
              border: 'none',
              padding: 0
            }}
            title={content.saveButton || 'Save'}
          >
            <img
              width="25"
              src={path + 'images/save_active.svg'}
              alt="Save"
            />
          </button>
        </div>

      </div>
    </div>
  );
};

export default SaveSection;